import { render, staticRenderFns } from "./StockCompareStats.vue?vue&type=template&id=68e284a6&"
import script from "./StockCompareStats.vue?vue&type=script&lang=js&"
export * from "./StockCompareStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports